import { render } from "./dol-switch-lang.vue?vue&type=template&id=171e40ce"
import script from "./dol-switch-lang.vue?vue&type=script&lang=js"
export * from "./dol-switch-lang.vue?vue&type=script&lang=js"

import "./dol-switch-lang.vue?vue&type=style&index=0&id=171e40ce&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__